import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 90%;
  left: 5%;
  position: relative;
  height: 40px;
  top: 60px;
  & ::selection{
    text-shadow: none !important;
    background: none !important;
    color: white;
  }
`
const Options = styled.p`
  font-size: 12px;
  font-family: 'Roboto';
  font-weight: 500;
  color: white;
  cursor: pointer;
  position: relative;
  float: left;
  margin-right: 10px;
  padding: 5px 10px;
  border-radius: 20px;
  transition: background 400ms;
  &:hover{
    opacity: ${props => props.currentFilterOption === props.option ? 1 : .7};
  }
  background: ${props => props.currentFilterOption === props.option && '#6f96b5'};
`

export default class FilterContainer extends React.Component {

  constructor(props){
    super(props);
    this.currentFilterOption = props.currentFilterOption;
    this.changeFilterOption = props.changeFilterOption;
  }

  componentWillReceiveProps(nextProps){
    this.currentFilterOption = nextProps.currentFilterOption;
  }

  render(){
    return(
      <Wrapper>
        <Options
          onClick={() =>{ this.changeFilterOption('percentage') }}
           option={'percentage'} currentFilterOption={this.currentFilterOption} >Breakdown by percentage</Options>
        <Options
          onClick={() =>{ this.changeFilterOption('location') }}
          option={'location'} currentFilterOption={this.currentFilterOption} >Breakdown by location</Options>
          <Options
            onClick={() =>{ this.changeFilterOption('companySize') }}
            option={'companySize'} currentFilterOption={this.currentFilterOption} >Breakdown by company's size</Options>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/FilterContainer.js